angular.module('gym.bulkMessages').controller('ShowMessageModalCtrl', ["$scope", "$modalInstance", "message", function($scope, $modalInstance, message) {
  $scope.message = message;
  return $scope.close = function() {
    return $modalInstance.dismiss();
  };
}]);
